import apiConfig from '@constants/apiConfig';

import DeviceManagerSavePage from './DeviceManagerSavePage';
import DeviceManagerListPage from '.';

export default {
    deviceManagerListPage: {
        path: '/inwen-device',
        title: 'Inwen Device',
        auth: true,
        component: DeviceManagerListPage,
        permission: [ apiConfig.inwen.getList.baseURL ],
    },
    deviceManagerSavePage: {
        path: '/inwen-device/:id',
        title: 'Inwen Device Save Page',
        auth: true,
        component: DeviceManagerSavePage,
        separateCheck: true,
        permission: [ apiConfig.inwen.create.baseURL, apiConfig.inwen.update.baseURL ],
    },
};
